import { render, staticRenderFns } from "./Propertity.vue?vue&type=template&id=e9a6875c&scoped=true&"
import script from "./Propertity.vue?vue&type=script&lang=js&"
export * from "./Propertity.vue?vue&type=script&lang=js&"
import style0 from "./Propertity.vue?vue&type=style&index=0&id=e9a6875c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e9a6875c",
  null
  
)

export default component.exports